import Service 			from "./../../Libs/Service";
import { Settings } 	from "./Settings";
import { Version } 		from "./Version";

let EndCard = new Service({

	Name: "EndCard",

	Libraries: [],

	Events: {

	},

	Actions: {

		//Получение проектов текущего издателя
		'EndCardScriptChanged': function() {

			if (Project.SelectedProject?.type === 'end-card') {

				Broadcast.call("Selected End Card Script Changed");

			}

		}

	},

	init() {

	},

	getEndCardVersion(project, version) {

		if (!project || !version) return null;
		if (project.type !== 'playable') return null;

		let endCardVersionId = Settings.getVersionSettingValue(version.id, 'end-card-version-id');
		return Version.Versions[endCardVersionId] || null;

	}/*,

	isProjectEndCardsLoaded(projectId) {

		let result = true;

		_.each(Version.VersionsByProject[projectId], version => {

			let endCardVersionId = Settings.getVersionSettingValue(version.id, 'end-card-version-id');

			if (endCardVersionId) {

				let version = 1

			}

		});

	}*/

});

//Делаем объект синглтоном чтобы при импортах возвращался тот же самый экземпляр
if (window.EndCard) EndCard = window.EndCard;
else window.EndCard = EndCard;

export { EndCard }

